import { PDFIcon } from "@root/assets/icons/PDFIcon";
import { XlsxIcon } from "@root/assets/icons/Xlsx";
import { DocxIcon } from "@root/assets/icons/DocxIcon";
import { PaperClipIcon } from "@root/assets/icons/PaperClipIcon";
import { FILE_KIND, type FileKind } from "@root/constants";

export function getFileType(fileName: string): FileKind {
  if (fileName?.toLowerCase()?.endsWith(".pdf")) return FILE_KIND.PDF;
  if (fileName?.toLowerCase()?.endsWith(".docx")) return FILE_KIND.DOCX;
  if (fileName?.toLowerCase()?.endsWith(".xlsx")) return FILE_KIND.XLSX;
  if (/\.(png|jpg|jpeg|gif|bmp)$/i?.test(fileName)) return FILE_KIND.IMAGE;
  return FILE_KIND.OTHER;
}

export function getFileIcon(fileName: string) {
  const fileType = getFileType(fileName);
  switch (fileType) {
    case FILE_KIND.PDF:
      return <PDFIcon  />;
    case FILE_KIND.XLSX:
      return <XlsxIcon/>;
    case FILE_KIND.DOCX:
      return <DocxIcon  />;
    default:
      return <PaperClipIcon />;
  }
}


